import { request } from '@src/core/api/request';
import { useMutation } from '@tanstack/react-query';

type TTestReminderPayload = {
  phone_number?: string;
  email?: string;
  template: number;
};

export const useTestReminderEmail = () => {
  return useMutation({
    mutationFn: async (body: TTestReminderPayload) => {
      return await request({
        url: `reminders/templates/messaging/email/`,
        method: 'POST',
        body,
      });
    },
  });
};

export const useTestReminderWhatsapp = () => {
  return useMutation({
    mutationFn: async (body: TTestReminderPayload) => {
      return await request({
        url: `reminders/templates/messaging/whatsapp/`,
        method: 'POST',
        body,
      });
    },
  });
};
